import gql from 'graphql-tag';

export default gql`
  query ProductMany {
    ProductMany(sort: CREATEDAT_DESC) {
      _id
      upc
      name
      price
      activeStores
      createdAt
      type
      zipCodes
      imageURL
      whereToFind
      department
      actualImageURL
      hotness
      comment
      actualUPC
      priority
    }
  }
`;
